// Coil configurator action types
export const LOAD_APPLICATION_STATE = "LOAD_APPLICATION_STATE";
export const LOAD_APPLICATION_STATE_SUCCESS = "LOAD_APPLICATION_STATE_SUCCESS";
export const LOAD_APPLICATION_STATE_FAILURE = "LOAD_APPLICATION_STATE_FAILURE";

export const SAVE_APPLICATION_STATE = "SAVE_APPLICATION_STATE";
export const SAVE_APPLICATION_STATE_SUCCESS = "SAVE_APPLICATION_STATE_SUCCESS";
export const SAVE_APPLICATION_STATE_FAILURE = "SAVE_APPLICATION_STATE_FAILURE";

export const SAVE_CATALOGUE = "SAVE_CATALOGUE";
export const SAVE_CATALOGUE_FAILURE = "SAVE_CATALOGUE_FAILURE";

export const SAVE_ASSUMPTIONS = "SAVE_ASSUMPTIONS";
export const SAVE_ASSUMPTIONS_FAILURE = "SAVE_ASSUMPTIONS_FAILURE";

export const HYDRATE_CATALOGUE = "HYDRATE_CATALOGUE";
export const UPDATE_CATALOGUE_DRAFT = "UPDATE_CATALOGUE_DRAFT";
export const REVERT_CATALOGUE_DRAFT = "REVERT_CATALOGUE_DRAFT";
export const SAVE_CATALOGUE_SUCCESS = "SAVE_CATALOGUE_SUCCESS";

export const HYDRATE_ASSUMPTIONS = "HYDRATE_ASSUMPTIONS";
export const UPDATE_ASSUMPTIONS_DRAFT = "UPDATE_ASSUMPTIONS_DRAFT";
export const REVERT_ASSUMPTIONS_DRAFT = "REVERT_ASSUMPTIONS_DRAFT";
export const SAVE_ASSUMPTIONS_SUCCESS = "SAVE_ASSUMPTIONS_SUCCESS";

export const HYDRATE_CONFIGURATIONS = "HYDRATE_CONFIGURATIONS";
export const SET_CONFIG_SEARCH = "SET_CONFIG_SEARCH";
export const SET_CONFIG_STATUS_FILTER = "SET_CONFIG_STATUS_FILTER";
export const SET_CONFIG_PAGE = "SET_CONFIG_PAGE";
export const SET_SELECTED_CONFIG_ID = "SET_SELECTED_CONFIG_ID";
export const SET_CONFIG_VIEW = "SET_CONFIG_VIEW";
export const OPEN_CONFIG_DETAIL = "OPEN_CONFIG_DETAIL";
export const CLOSE_CONFIG_DETAIL = "CLOSE_CONFIG_DETAIL";
export const UPSERT_CONFIGURATION = "UPSERT_CONFIGURATION";
export const DELETE_CONFIGURATION = "DELETE_CONFIGURATION";

export const OPEN_CONFIG_MODAL = "OPEN_CONFIG_MODAL";
export const CLOSE_CONFIG_MODAL = "CLOSE_CONFIG_MODAL";
export const SUBMIT_CONFIG_MODAL = "SUBMIT_CONFIG_MODAL";
export const SUBMIT_CONFIG_MODAL_FAILURE = "SUBMIT_CONFIG_MODAL_FAILURE";
export const CLEAR_CONFIG_MODAL_ERRORS = "CLEAR_CONFIG_MODAL_ERRORS";

export const RECALCULATE_CONFIGURATION = "RECALCULATE_CONFIGURATION";

export const HYDRATE_MEASUREMENTS = "HYDRATE_MEASUREMENTS";
export const UPSERT_MEASUREMENT = "UPSERT_MEASUREMENT";
export const MEASUREMENT_SAVE_SUCCESS = "MEASUREMENT_SAVE_SUCCESS";
export const MEASUREMENT_SAVE_FAILURE = "MEASUREMENT_SAVE_FAILURE";
export const DELETE_MEASUREMENT = "DELETE_MEASUREMENT";

export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_GLOSSARY_OPEN = "SET_GLOSSARY_OPEN";
export const HYDRATE_GLOSSARY = "HYDRATE_GLOSSARY";
export const SAVE_GLOSSARY_ENTRY = "SAVE_GLOSSARY_ENTRY";
export const SAVE_GLOSSARY_ENTRY_SUCCESS = "SAVE_GLOSSARY_ENTRY_SUCCESS";
export const SAVE_GLOSSARY_ENTRY_FAILURE = "SAVE_GLOSSARY_ENTRY_FAILURE";
export const SHOW_TOAST = "SHOW_TOAST";
export const CLEAR_TOAST = "CLEAR_TOAST";

// Legacy fetch types (kept for compatibility)
export const FETCH_CONFIGURATIONS = "FETCH_CONFIGURATIONS";
export const FETCH_CONFIGURATIONS_SUCCESS = "FETCH_CONFIGURATIONS_SUCCESS";
export const FETCH_CONFIGURATIONS_FAILURE = "FETCH_CONFIGURATIONS_FAILURE";
